import {HoldingFileReqRes} from 'src/app/dashboard/shared/holding/HoldingFileReqRes.model';
import {ProjectedPerformance} from 'src/app/shared/models/ProjectedPerformance.model';
import {LenderInformation} from 'src/app/shared/models/LenderInformation.model';
import {CurrencyModel} from 'src/app/shared/models/CurrencyModel';
import InvestmentType from 'src/app/shared/enums/InvestmentType.enum';
import AreaUnit from 'src/app/shared/enums/AreaUnit.enum';
import {ProjectBudget} from 'src/app/shared/models/ProjectBudget.model';
import {GpFundReqRes} from '../funds/GpFundReqRes.model';
import InvestmentSecurityType from 'src/app/shared/enums/InvestmentSecurityType.enum';
import {GpHoldingListItemReqRes} from '../shared/holding/GpHoldingListItem.model';
import {GpHolding} from '../shared/holding/GpHolding.model';
import { CommitmentsEnabled } from 'src/app/shared/enums/CommitmentsEnabled.enum';
import { OwnershipCalculationType } from 'src/app/shared/enums/OwnershipCalculationType.enum';
import { LpOwnershipVisibility } from 'src/app/shared/enums/LpOwnershipVisibility.enum';

export class GpAssetListItemReqRes extends GpHoldingListItemReqRes {
  public email: string;
  public isCollectDeposists: boolean;
  public canSetAsPrivate: boolean;
  public attachments: HoldingFileReqRes[];

  // Front only property:
  public isExampleAsset = false;

  public percentsFunded: number;
  public fundraisingTargetAmount: number;
  public initialCurrency: CurrencyModel;
  public estimatedClosingDate: Date;
}

export class GpAssetReqRes extends GpHolding {
  public isCollectDeposists: boolean;
  public canSetAsPrivate: boolean;

  // Front only property:
  public isExampleAsset = false;

  public investmentType: InvestmentType;
  public investmentTypeOther: string;
  public legalName: string;

  public areaUnits: AreaUnit;
  public lotSizeArea: number;
  public stories: number;
  public residentialUnits: number;
  public retailUnits: number;
  public rooms: number;
  public grossBuildingArea: number;
  public residentialNetSellableArea: number;
  public retailNetSellableArea: number;
  public numberOfSites: number;

  public projectedPerformance: ProjectedPerformance;
  public lenderInformation: LenderInformation;

  public projectBudgetOriginal: ProjectBudget;
  public projectBudgetUpdated: ProjectBudget;

  public fundId: number;
  public fund: GpFundReqRes;

  public initialSecurityType: InvestmentSecurityType;

  // #region Cumulative information:

  public plannedCostsToDate: number;
  public actualCostsToDate: number;

  public outstandingLoanAmountToDate: number;

  public gpEquityFromTotalEquity: number;
  public estimatedMarketValue: number;

  public constructionStartDate: Date;
  public constructionEndDate: Date;

  public cumulativeProjectedPerformance: ProjectedPerformance;
  // #endregion

  public initialCurrency: CurrencyModel;
  public initialCurrencyId: number;


  public commitmentsEnabled: CommitmentsEnabled;
  public ownershipCalculationType: OwnershipCalculationType;
  public lpOwnershipVisibility: LpOwnershipVisibility;
  public displayCommitments: boolean;
}

